<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle v-if="glow" cx="20" cy="20" r="15" fill="#e74c3c" opacity="0.07" />
    <circle v-if="glow" cx="52" cy="52" r="16" fill="#2ecc71" opacity="0.07" />
    <!-- Red — top-left -->
    <circle cx="20" cy="20" fill="#e74c3c" opacity="0.9" class="orb-1">
      <animate v-if="animated" attributeName="r" values="9;7;10;8;9" dur="2.4s" repeatCount="indefinite" />
      <animate v-if="animated" attributeName="opacity" values="0.9;0.6;1;0.7;0.9" dur="2.4s" repeatCount="indefinite" />
    </circle>
    <circle v-if="!animated" cx="20" cy="20" r="9" fill="#e74c3c" opacity="0.9" />
    <!-- Yellow — top-right -->
    <circle cx="50" cy="24" fill="#f1c40f" opacity="0.9" class="orb-2">
      <animate v-if="animated" attributeName="r" values="7;9;5.5;8;7" dur="2.64s" repeatCount="indefinite" />
      <animate v-if="animated" attributeName="opacity" values="0.9;0.5;1;0.6;0.9" dur="2.64s" repeatCount="indefinite" />
    </circle>
    <circle v-if="!animated" cx="50" cy="24" r="7" fill="#f1c40f" opacity="0.9" />
    <!-- Blue — bottom-left -->
    <circle cx="22" cy="50" fill="#3498db" opacity="0.85" class="orb-3">
      <animate v-if="animated" attributeName="r" values="6;8;5;7.5;6" dur="2.16s" repeatCount="indefinite" />
      <animate v-if="animated" attributeName="opacity" values="0.85;1;0.5;0.9;0.85" dur="2.16s" repeatCount="indefinite" />
    </circle>
    <circle v-if="!animated" cx="22" cy="50" r="6" fill="#3498db" opacity="0.85" />
    <!-- Green — bottom-right -->
    <circle cx="52" cy="52" fill="#2ecc71" opacity="0.9" class="orb-4">
      <animate v-if="animated" attributeName="r" values="9.5;7;10.5;8;9.5" dur="2.88s" repeatCount="indefinite" />
      <animate v-if="animated" attributeName="opacity" values="0.9;0.6;0.8;1;0.9" dur="2.88s" repeatCount="indefinite" />
    </circle>
    <circle v-if="!animated" cx="52" cy="52" r="9.5" fill="#2ecc71" opacity="0.9" />
  </svg>
</template>

<script setup lang="ts">
defineProps({
  size: { type: Number, default: 40 },
  glow: { type: Boolean, default: true },
  animated: { type: Boolean, default: false },
});
</script>
